<template>
	<taskyType :type="8" />
</template>

<script>
import taskyType from '@/components/taskyType/taskyType';
export default {
	components: {
		taskyType
	}
};
</script>

<style></style>
